export type TrackingVarsType = {
  setConsentGiven: (isConsentGiven: boolean) => void;
  setAnalyticsTrackingEnabled: (isAnalyticsTrackingEnabled: boolean) => void;
  isConsentGiven: () => boolean;
  isAnalyticsTrackingEnabled: () => boolean;
};

export class TrackingVars implements TrackingVarsType {
  private consentGiven: boolean;
  private analyticsTrackingEnabled: boolean;

  constructor(consentGiven = false, analyticsTrackingEnabled = false) {
    this.consentGiven = consentGiven;
    this.analyticsTrackingEnabled = analyticsTrackingEnabled;
  }

  public setConsentGiven(isConsentGiven: boolean) {
    this.consentGiven = isConsentGiven;
  }

  public setAnalyticsTrackingEnabled(isAnalyticsTrackingEnabled: boolean) {
    this.analyticsTrackingEnabled = isAnalyticsTrackingEnabled;
  }

  public isConsentGiven() {
    return this.consentGiven;
  }

  public isAnalyticsTrackingEnabled() {
    return this.analyticsTrackingEnabled;
  }
}

export const trackingVars = new TrackingVars();
